import React, { useState, useEffect } from 'react';
import useReveal from '../../hooks/useReveal';
import BlueImage from "../../assets/images/blueServer.png";
// import search from "../../assets/svg-icons/search.svg";
// import database from "../../assets/svg-icons/database.svg";
// import optimized from "../../assets/svg-icons/optimized.svg";
// import shield from "../../assets/svg-icons/shield.svg";
import VPS from "../../components/FAQs/vpsFAQ";
import Domain from "../../components/FAQs/domainFAQ";
import Email from "../../components/FAQs/EmailFAQ";
import VPN from "../../components/FAQs/vpnFAQ";
import { Link } from "react-router-dom";
// import emailServicesBanner from "../../assets/images/email-illustration.svg";
// import domainBanner from "../../assets/images/domain banner.svg";
import support from "../../assets/images/support phone.png";
// import cooperative from "../../assets/images/cooperative-illustration.svg";
import vpsIllustration from "../../assets/images/vps-illustration.svg";
import SEO from "../../components/SEO";
import { LucideArrowRight, LucideArrowLeft, ShieldCheck, CheckCircle2 } from "lucide-react";
import ndpc from "../../assets/images/ndpc-logo.png";


const LandingPage = () => {


  const [selectedOption, setSelectedOption] = useState("vps");

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const idle =
    "py-4 px-6 text-xs cursor-pointer border border-[#00000030] dark:border-[#ffffff30] rounded-md text-[#00000080] dark:text-[#ffffff80]";
  const active =
    "m-0 py-4 px-6 text-xs cursor-pointer bg-[#1DA1F2] rounded-md text-white";

  const testimonials = [
  {
    quote: "After over a year of using CloudVantage's services, I can confidently say they deliver exceptional reliability and performance. The service has been consistently excellent, with minimal downtime and robust infrastructure that scales with our needs. CloudVantage has proven to be a dependable partner for our cloud infrastructure requirements. Highly recommend!",
    name: "Abdullah Olatunji",
    company: "Data Analyst, Payvantage Limited"
  },
  {
    quote: "CloudVantage has been a game-changer for our infrastructure. We've seen faster deployment times and reduced downtime across the board.",
    name: "Tosin Ogunsanya",
    company: "Customer Experience and Growth, Macrotel-Innovations"
  },
  {
    quote: "As a digital fundraising platform serving the faith community, stability and security are everything. Cloud Vantage gives us both — plus the flexibility to scale during peak donation periods like Ramadan and Dhul Hijjah.",
    name: "Tobi Amusa",
    company: "Product Lead, MosquePay"
  },
  {
    quote: "We needed a reliable cloud solution for hosting our weekly TV episodes and livestream content. Cloud Vantage delivered seamless performance, zero buffering, and the kind of uptime we only dreamed of before.",
    name: "Subomi Sule-Odu",
    company: "Backend Engineer, HalalNest"
  }
];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-scroll every 7 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const [heroRef, heroVisible] = useReveal();
  const [cardsRef, cardsVisible] = useReveal();
  const [trustedRef, trustedVisible] = useReveal();
  const [whyRef, whyVisible] = useReveal();
  const [testimonialsRef, testimonialsVisible] = useReveal();
  const [ndpcRef, ndpcVisible] = useReveal();
  const [faqRef, faqVisible] = useReveal();

    return (
      <div>
        {/* SEO Meta Tags */}
        <SEO
          title="Affordable Cloud Solutions, Services & Security"
          description="Power your business with affordable hybrid cloud management, cloud native technologies, and advanced cloud security solutions tailored for growth."
          keywords="cloud solutions, hybrid cloud management, cloud security, infrastructure as a service, IaaS, cloud hosting, VPS hosting, cloud services"
          author="CloudVantage"
          ogTitle="Affordable Cloud Solutions, Services & Security - CloudVantage"
          ogDescription="Power your business with affordable hybrid cloud management, cloud native technologies, and advanced cloud security solutions tailored for growth."
          ogImage="/assets/images/cloudvantage-og-image.jpg" // Update with actual image path
          ogUrl={window.location.href}
        />

        {/* hero section */}
        <div ref={heroRef} className={`h-[70vh] md:h-[65vh] flex items-center ${heroVisible ? 'animate-reveal' : 'opacity-0'}`}>
          <div className="w-full lg:w-[60%] py-16 px-4">
          <h1 className="text-4xl font-bold text-black dark:text-white leading-tight crimson-font ">
            Secure, Scalable Cloud Solutions for Modern Businesses
          </h1>
          <p className="text-lg text-black/70 dark:text-white/80 mb-8 w-full leading-relaxed">
            From hybrid cloud management to cloud-native security, CloudVantage delivers trusted platforms, services, and infrastructure as a service (IaaS) to power your growth.
          </p>
          <Link to={"/sign-in"}>
            <button className="bg-[#1DA1F2] text-white text-sm px-8 py-4 rounded-sm hover:bg-[#1a8fd1] transition-colors">
              Explore Cloud Solutions
            </button>
          </Link>
          </div>
        </div>

        <div ref={cardsRef} className={`px-4 grid grid-cols-1 lg:grid-cols-12 gap-4 items-center ${cardsVisible ? 'animate-reveal' : 'opacity-0'}`}>
          <div className="lg:col-span-8 bg-brandGreen h-full flex items-center rounded-md">
            <div className=" p-6 md:p-10  grid grid-cols-1 md:grid-cols-12 items-center gap-4">
              <div className="col-span-1 md:col-span-6 lg:col-span-7">
                <p className="text-lg leading-snug crimson-font font-bold">
                  Virtual Private Servers - Supercharge your VPS hosting with
                  incredible speed and support
                </p>
                <p className="text-sm mt-4 font-normal">
                  Unlock unparalleled performance with lightning-fast speed and
                  unwavering support. Maximize efficiency, bolster security, and
                  unleash innovation across your VPS hosting environment.
                </p>
                <div className="mt-6">
                  <Link to={"/sign-in"}>
                    <button className="bg-black text-white text-xs px-6 py-4 rounded-sm hover:bg-gray-800 transition-colors">
                      Setup your cloud account
                    </button>
                  </Link>
                </div>
              </div>
              <div className="col-span-1 md:col-span-6 lg:col-span-5 grid justify-items-stretch">
                <img src={vpsIllustration} alt="" className="md:justify-self-end" />
              </div>
            </div>
          </div>
          <div className="bg-brandBlue rounded-md h-full lg:col-span-4 p-6 md:p-10 flex items-center">
          <div className="">
            <p className="text-lg text-pretty leading-snug crimson-font font-bold">
              Experience the Future with Virtual Private Cloud (VPC)!
            </p>
            <div className="text-sm mb-6 mt-2">
              <div>
                Take control of your business operations with a tailored Virtual
                Private Cloud solution. With VPC, enjoy:
              </div>
              <ul className=" list-disc list list-inside mt-3">
                <li>Data privacy</li>
                <li>improved security</li>
                <li>Scalability</li>
              </ul>
            </div>
            <div className="grid gap-2">
              <a href="mailto:vpc@cloudvantage.com.ng" className="bg-black text-white text-xs px-6 py-4 rounded-sm w-fit hover:bg-gray-800 transition-colors">Contact sales</a>
              <div className="text-xs text-gray-600">Or call (+234) 906 943 4255</div>
            </div>
          </div>
          </div>
        </div>

        {/* Trusted experts */}
        <div ref={trustedRef} className={`bg-[#B3E0FF] py-20 mx-4 mt-4 rounded-md grid grid-cols-1 lg:grid-cols-2 items-center gap-8 ${trustedVisible ? 'animate-reveal' : 'opacity-0'}`}>
          <div className="px-10">
            <img src={BlueImage} alt="" />
          </div>
          <div className="text-[#263238] text-center lg:text-start p-4 md:p-10">
            <p className="text-lg md:text-xl text-pretty leading-snug crimson-font font-bold">
              Trusted Experts In Making It Simple!
            </p>
            <p className="mt-2 text-sm mb-6">
              Unlock the potential of your cloud environments with our
              cutting-edge solutions. Effortlessly oversee your cloud
              infrastructure with the right tools and expertise.
            </p>
            <div className="flex justify-center lg:justify-start">
              <Link to={"/sign-in"}>
                <button className="bg-[#1DA1F2] text-white text-xs px-6 py-4 rounded-sm hover:bg-[#1a8fd1] transition-colors">
                  Get started
                </button>
              </Link>
            </div>
          </div>
        </div>

        {/* why choose us */}
        <div ref={whyRef} className={`bg-gradient-to-r from-brandBlue to-brandGreen gap-6 px-6 md:px-16 py-6 mx-4 mt-4 rounded-md items-center grid grid-cols-1 md:grid-cols-3 ${whyVisible ? 'animate-reveal' : 'opacity-0'}`}>
          <div className="md:col-span-2 order-2 md:order-1 text-center md:text-start mb-6 md:mb-0">
            <p className="text-lg leading-snug crimson-font font-bold">
              Why choose CloudVantage
            </p>
            <p className="mt-2 text-sm mb-8">
              Because we understand that the finest technology is only as
              effective as the team supporting it. That's why we provide expert
              assistance every step of the way.
            </p>
            <Link to={"/sign-in"}>
              <button className="bg-black text-white text-xs px-6 py-4 rounded-sm hover:bg-gray-800 transition-colors">
                Get started
              </button>
            </Link>
          </div>
          <div className="order-1 md:order-2">
            <img src={support} alt="" />
          </div>
        </div>


        {/* testimonials */}
        <div ref={testimonialsRef} className={`rounded-md mx-4 my-10 py-12 px-6 text-center transition-all duration-300 ease-in-out ${testimonialsVisible ? 'animate-reveal' : 'opacity-0'}`}>
          <p className="text-2xl font-bold crimson-font mb-6 dark:text-white">
            Reviews From Our Clients
          </p>

          <div className="max-w-3xl mx-auto px-4 transition-all duration-500 ease-in-out">
            <p className="italic text-sm md:text-base text-black/70 dark:text-white/70 mb-6">
              "{testimonials[currentIndex].quote}"
            </p>
            <div className="font-bold text-black dark:text-white">{testimonials[currentIndex].name}</div>
            <div className="text-xs text-black/50 dark:text-white/50">{testimonials[currentIndex].company}</div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`h-2 w-2 rounded-full cursor-pointer transition-all duration-300 ${
                  i === currentIndex ? 'bg-[#1DA1F2]' : 'bg-gray-300'
                }`}
              ></div>
            ))}
          </div>

          {/* Buttons */}
          <div className="mt-6 flex justify-center gap-6">
            <button
              onClick={prevTestimonial}
              className="bg-black/5 dark:bg-white/10 text-white p-4 text-xs rounded-full hover:bg-black/10 dark:hover:bg-white/20 transition-colors"
            >
              <LucideArrowLeft className="w-4 h-4 text-black dark:text-white"/>
            </button>
            <button
              onClick={nextTestimonial}
              className="bg-black/5 dark:bg-white/10 text-white p-4 text-xs rounded-full hover:bg-black/10 dark:hover:bg-white/20 transition-colors"
            >
              <LucideArrowRight className="w-4 h-4 text-black dark:text-white" />
            </button>
          </div>
        </div>

        {/* NDPC Compliance */}
        <div ref={ndpcRef} className={`my-4 mx-4 ${ndpcVisible ? 'animate-reveal' : 'opacity-0'}`} id="ndpc">
          <div className="rounded-2xl overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2">

              {/* Left: Content */}
              <div className="p-8 md:p-12 lg:p-14">
                <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full bg-[#1DA1F2]/10 text-[#1DA1F2] border border-[#1DA1F2]/20 mb-6">
                  <ShieldCheck className="w-3.5 h-3.5" />
                  Data Protection Compliant
                </span>

                <h2 className="text-2xl md:text-3xl font-bold crimson-font text-gray-900 dark:text-white leading-tight mb-4">
                  NDPC Compliance &amp; Data Protection
                </h2>

                <p className="text-sm md:text-[15px] text-gray-600 dark:text-gray-400 leading-relaxed mb-8 max-w-md">
                  We adhere to the Nigeria Data Protection Commission (NDPC) guidelines to ensure your personal information is securely handled, processed, and protected.
                </p>

                <div className="grid gap-3 mb-8">
                  {[
                    "Secure data handling & processing",
                    "Full NDPC regulatory alignment",
                    "User privacy by design",
                  ].map((point) => (
                    <div key={point} className="flex items-center gap-3">
                      <CheckCircle2 className="w-4 h-4 text-[#1DA1F2] flex-shrink-0" />
                      <span className="text-sm text-gray-700 dark:text-gray-300">{point}</span>
                    </div>
                  ))}
                </div>

                <a
                  href="https://ndpc.gov.ng"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm font-medium text-[#1DA1F2] hover:text-[#1a8fd1] transition-colors duration-200 group"
                >
                  Learn about NDPC
                  <LucideArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-200" />
                </a>
              </div>

              {/* Right: Logo + status badges */}
              <div className="p-8 md:p-12 lg:p-14 flex flex-col items-center justify-center border-t border-gray-200 dark:border-white/[0.08] md:border-t-0 md:border-l">
                <div className="relative mb-6">
                  <div className="p-4 rounded-2xl bg-white flex items-center justify-center hover:shadow-lg transition-shadow duration-300">
                    <img src={ndpc} alt="NDPC logo" className="w-[200px] object-contain" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#1DA1F2] flex items-center justify-center shadow-md">
                    <ShieldCheck className="w-4 h-4 text-white" />
                  </div>
                </div>

                <p className="text-sm font-semibold text-gray-900 dark:text-white text-center mb-1">
                  Nigeria Data Protection Commission
                </p>

              </div>

            </div>
          </div>
        </div>

        {/* FAQs and footer */}
        <div ref={faqRef} className={`my-4 mx-4 rounded-md py-16 grid gap-8 ${faqVisible ? 'animate-reveal' : 'opacity-0'}`} id="faq">
          <div className="">
            <p className="text-2xl font-bold crimson-font mb-6 dark:text-white">
              Frequently Asked Questions.
            </p>
            <div className="grid grid-cols-2 text-center md:flex gap-2 mb-6">
              <span
                className={`${
                  selectedOption === "vps" ? "active" + active : idle
                }`}
                onClick={() => handleOptionClick("vps")}
              >
                VPS
              </span>
              <span
                className={`${
                  selectedOption === "domain" ? "active" + active : idle
                }`}
                onClick={() => handleOptionClick("domain")}
              >
                Domains
              </span>
              <span
                className={`${
                  selectedOption === "email" ? "active" + active : idle
                }`}
                onClick={() => handleOptionClick("email")}
              >
                Email services
              </span>
              <span
                className={`${
                  selectedOption === "vpn" ? "active" + active : idle
                }`}
                onClick={() => handleOptionClick("vpn")}
              >
                VPN
              </span>
            </div>
            <div
              style={{ display: selectedOption === "vps" ? "block" : "none" }}
            >
              {" "}
              <VPS />{" "}
            </div>
            <div
              style={{
                display: selectedOption === "domain" ? "block" : "none",
              }}
            >
              {" "}
              <Domain />{" "}
            </div>
            <div
              style={{ display: selectedOption === "email" ? "block" : "none" }}
            >
              {" "}
              <Email />{" "}
            </div>
            <div
              style={{ display: selectedOption === "vpn" ? "block" : "none" }}
            >
              {" "}
              <VPN />{" "}
            </div>
          </div>
          <div className="px-4 md:px-16">
            <hr className="dark:opacity-10" />
          </div>
          <div className="px-4 md:px-16">
            <div className="text-center px-8">
              <p className="font-bold mb-2 crimson-font text-lg dark:text-white">
                Take your website online with CloudVantage Hosting
              </p>
              <p className="text-[13px] mb-5 dark:text-white/50">
                Enjoy special introductory pricing billed monthly
              </p>
              <Link to={"/sign-in"} className="flex justify-center">
                <button className="bg-[#1DA1F2] text-white flex items-center gap-3 text-sm px-6 py-4 rounded-sm hover:bg-[#1a8fd1] transition-colors">
                  Get started
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
}
 
export default LandingPage;